import  * as React from "react";
import { observer } from "mobx-react";
import { IOptimizerSingleTileParams } from "./IOptimizerSingleTileParams";

@observer
export class OptimizerSingleTile extends React.Component<IOptimizerSingleTileParams>{
    constructor(props: IOptimizerSingleTileParams) {
        super(props, undefined);
    }

    render() {
        return <div className="OptimizerSingleTile">
                   <div className="box-for-variable-and-optimal-variable-wrapper">
                       <div className="box-for-variable-and-optimal-variable">
                           <div className="variable-wrapper">
                               {this.props.title !== "Estimated Total" &&
                                   <p className="variable-name">{this.props.title}</p>
                               }
                               {this.props.title === "Estimated Total" &&
                                   <p className="variable-name">"Total"</p>
                               }
                               <div className="horizontal-line"></div>
                               <p className="optimal-variable-name">Opt. </p>
                               <p className="variable-number">{this.props.optimalValue}</p>
                               <p className="variable-unit">{this.props.unit}</p>
                           </div>
                           <div className="optimal-variable-wrapper">
                               <p className="optimal-variable-number">{this.props.highlightValue != null
                                   ? this.props.highlightValue
                                   : "-"}</p>
                           </div>
                       </div>
                   </div>
               </div>;
    }
}
